import { createContextWithHook } from '@chilipiper/utils'

const { ExpiredSessionBaseProvider, useExpiredSessionContext } =
  createContextWithHook<boolean>()('ExpiredSession')

export {
  ExpiredSessionBaseProvider as ExpiredSessionProvider,
  useExpiredSessionContext as useExpiredSession,
}
